
export type IPublicTypeHotkeyCallback = (e: KeyboardEvent, combo?: string) => any | false;
